import { render, staticRenderFns } from "./QTDogRequestCard.vue?vue&type=template&id=c09d8960"
import script from "./QTDogRequestCard.vue?vue&type=script&lang=ts"
export * from "./QTDogRequestCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports